export default function range(length: number) {
    const rangeArray = new Array(length)
    for (let index = 0; index < length; index++) {
        rangeArray[index] = index
    }
    return rangeArray
}
